<template>
    <b-modal id="create_cron_subscriber_modal" @ok="createCronSubscriber">
        <template slot="modal-title">Create a new cron subscriber</template>
        <form ref="create_cron_subscriber_form">
            <b-form-group
                    label="Name"
                    label-for="name">
                <b-form-input
                        id="name"
                        :state="validateName"
                        v-model="new_cron_subscriber.name"
                        autofocus
                        required/>
                <b-form-invalid-feedback :state="validateName">
                    Name is invalid, it needs at least {{minNameLength}} characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Interval in minutes"
                    label-for="interval">
                <b-form-input
                        id="interval"
                        :state="validateInterval"
                        v-model="new_cron_subscriber.interval"
                        type="number"
                        required/>
                <b-form-invalid-feedback :state="validateInterval">
                    Interval is invalid.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Active"
                    label-for="active">
                <b-form-checkbox
                        id="active"
                        v-model="new_cron_subscriber.active"
                        required/>
            </b-form-group>
            <b-form-group
                    label="Project"
                    label-for="project">
                <b-form-select
                        id="project"
                        :state="validateProject"
                        v-model="new_cron_subscriber.project_id"
                        :options="project_options"
                        required/>
                <b-form-invalid-feedback :state="validateProject">
                    Select a project.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Event to fire"
                    label-for="event">
                <b-form-select
                        id="event"
                        :state="validateEvent"
                        v-model="new_cron_subscriber.event_name"
                        :options="event_options"
                        required/>
                <b-form-invalid-feedback :state="validateEvent">
                    Select an event.
                </b-form-invalid-feedback>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
    import CronSubscriberRepository from '../../repositories/cron_subscriber.repository';

    export default {
        props: {
            project_options: {
                type: Array,
                default: () => []
            },
            event_options: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                new_cron_subscriber: CronSubscriberRepository.blankSubscriber(),
                minNameLength: process.env.VUE_APP_VALIDATION_CRONSUBSCRIBER_MIN_NAME_LENGTH
            }
        },
        methods: {
            checkFields() {
                if (CronSubscriberRepository.validate.name(this.new_cron_subscriber.name) === false) return false;
                if (CronSubscriberRepository.validate.interval(this.new_cron_subscriber.interval) === false) return false;
                if (CronSubscriberRepository.validate.project(this.new_cron_subscriber.project_id) === false) return false;
                if (CronSubscriberRepository.validate.event(this.new_cron_subscriber.event_name) === false) return false;
                return true;
            },
            createCronSubscriber(modal) {
                if (this.$refs.create_cron_subscriber_form.checkValidity() && this.checkFields()) {
                    this.$emit('change-create-loading');
                    CronSubscriberRepository.post(this.new_cron_subscriber).then(res => {
                        if (res.status === 201) { // Status 201 means created
                            // Emit the cron-subscriber-created subscribers.
                            this.$emit('change-create-loading');
                            this.$emit('cron-subscriber-created', res.data);
                            // Restore the create cron subscribers form.
                            this.new_cron_subscriber = CronSubscriberRepository.blankSubscriber();
                            // Notify the user.
                            this.$bvToast.toast(`Cron subscriber ${res.data.name} successfully created.`, {
                                title: `Cron subscriber created.`,
                                variant: 'success',
                                solid: true
                            });
                        } else {
                            this.$bvToast.toast('Looks like something went wrong while creating a new cron subscriber.', {
                                title: `Cron subscriber creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    }).catch(error => {
                        this.$emit('change-create-loading');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the new cron subscriber. Check the value\'s of all the fields', {
                                title: `Cron subscriber creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while creating a new cron subscriber.', {
                                title: `Cron subscriber creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateName() {
                return CronSubscriberRepository.validate.name(this.new_cron_subscriber.name);
            },
            validateInterval() {
                return CronSubscriberRepository.validate.interval(this.new_cron_subscriber.interval);
            },
            validateProject() {
                return CronSubscriberRepository.validate.project(this.new_cron_subscriber.project_id);
            },
            validateEvent() {
                return CronSubscriberRepository.validate.event(this.new_cron_subscriber.event_name);
            }
        }
    }
</script>
